import { Link, useNavigate } from 'react-router-dom';
import searchicon from '../../../assets/images/search.png';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { clearMessage } from '../../../slices/messages';
import Swal from 'sweetalert2';
import { deleteJob, myJob } from '../../../slices/jobs';
import Header from '../../dt/dt';
import Pagination from '../../dt/Pagination';
import empty_table from '../../../assets/images/empty_table.png';
import { useTranslation } from 'react-i18next';

const MyJobs = () => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const navigate = useNavigate();

    const { messageStatus } = useSelector((state) => state.message);
    const { user} = useSelector((state) => state.auth);
    const { jobs } = useSelector((state) => state.jobs);

    let currentLang = localStorage.getItem('activeLanguage') ? localStorage.getItem('activeLanguage') : 'en';
    const [activeLang, setActiveLang] = useState(currentLang);

    const [currentPage, setCurrentPage] = useState(1);
    const [defaultSort, setSort] = useState({ 'sort_column': 'created_at', 'sort_type': 'desc' });
    const [search, setSearch] = useState("");

    let PageSize = 10;

    let tmpVar = {
        page: currentPage,
        sort: defaultSort,
        activeLang: activeLang,
        search: search
    };

    const [filterOptions, setFilterOption] = useState(tmpVar);

    const [successMsg, setSuccessMsg] = useState(false);

    useEffect(() => {
        if(user && user.approve == "N") {
            navigate('/profile');
        }
        if (messageStatus == "Success") {    
            setSuccessMsg(true);
        }
        dispatch(clearMessage());

        let tmpVar = {
            page: currentPage,
            sort: defaultSort,
            activeLang: activeLang,
            search: search
        };

        dispatch(myJob(tmpVar));
    }, [defaultSort, currentPage, search]);

    const changePageSize = (pageNumber) => {
        setSort({ 'sort_column': 'created_at', 'sort_type': 'desc' });
        setCurrentPage(pageNumber);
    }

    const columns_data = [
        {
            key: "title_" + activeLang,
            text: t('title'),
            className: "",
            align: "left",
            sortable: true,
            defaultSort: false,
        },
        {
            key: "contact_no",
            text: t("contact_no"),
            className: "",
            align: "left",
            sortable: true,
            defaultSort: false,
        },
        {
            key: "created_at",
            text: t("createdAt"),
            className: "",
            align: "left",
            sortable: true,
            defaultSort: false,
        },
        {
            key: "job_status",
            text: t("jobStatus"),
            className: "",
            sortable: false,
            align: "left",
            defaultSort: false,
        },
        {
            key: "status",
            text: t("status"),
            className: "",
            sortable: false,
            defaultSort: 'asc',
        },
        {
            key: "action",
            text: t("action"),
            className: "",
            sortable: false,
            align: "left",
            defaultSort: false,
        }
    ];

    const [columns, setColumns] = useState(columns_data);

    const clickaction = (column, type, index) => {
        setSort({ 'sort_column': column, 'sort_type': type });
    }

    const searchValue = (e) => {
        setSearch(e.target.value);
    }

    const deleteItem = (id) => {
        Swal.fire({
            title: t('delete_confirm'),
            showDenyButton: false,
            showCancelButton: true,
            icon: 'success',
            confirmButtonText: t('delete'),
            cancelButtonText: t('cancel'),
            allowOutsideClick: true,
            confirmButtonColor: "#61B653"
        }).then(function (result) {
            if (result.isConfirmed) { 
                dispatch(deleteJob(id)).unwrap()
                    .then(() => {
                        let tmpVar = {
                            page: currentPage,
                            sort: defaultSort,
                            activeLang: activeLang,
                            search: search
                        };

                        dispatch(myJob(tmpVar));
                        Swal.fire({
                            title: t('Job_post'),
                            showDenyButton: false,
                            showCancelButton: false,
                            icon: 'success',
                            confirmButtonText: t('okay'),
                            allowOutsideClick: true,
                            confirmButtonColor: "#61B653"
                        });
                    })
                    .catch((e) => {

                    });
            } else {

            }
        });
    }

    return (
        <div className="container">
            <section className="mt-5 pt-5">
                <div className="row">
                    <div className='col-md-6'>
                        <div className='section-title'>
                            <h1><span className='font-color-1'>{t('my')}</span> <span className='font-color-2'>{t('jobs')}</span></h1>
                            <p className='mb-0'>{t('here_job')}</p>
                        </div>
                    </div>
                    <div className='col-md-6 table-search-area mt-5'>
                        <div className='table-search'>
                            <input type='search' className='form-control' placeholder={t('search_here')} onChange={e => searchValue(e)} />
                            <img src={searchicon} />
                        </div>
                        <div className='table-search-btn'>
                            <Link to="/create-job" className='btn btn-primary'>{t('create_job')}</Link>
                        </div>
                    </div>
                    <div className='col-md-12 mt-2-5'>
                        {successMsg &&
                            <div className="col-md-12 error-section">
                                <div className="alert alert-success" role="alert" > {t('job_save')}  </div>
                            </div>
                        }
                        <div className='table-responsive table-area bg-2 font-color'>
                            <table className='table '>
                                <Header config={columns} handleClick={clickaction} defaultSort={defaultSort} />

                                <tbody>
                                    {
                                        jobs != null && jobs.total > 0 ?
                                            jobs?.res.map((item, index) => {
                                                return (
                                                    <tr key={item.id}>
                                                        <td>{item.title}</td>
                                                        <td>{item.contact_no}</td>
                                                        <td>{item.created_at}</td>
                                                        <td>{item.status == 0 ? t('pending') : t('approved')}</td>
                                                        <td>{item?.job_status == 'Vacant' ? t('Vacant') :  t('Filled') }</td>
                                                        <td className='d-flex'>
                                                            <Link to={`/job/edit/${item.id}`} className='btn btn-primary btn-sm'><i className='fa fa-pencil'></i></Link>
                                                            <button className='btn btn-primary btn-sm ms-2' onClick={() => deleteItem(item.id)}><i className='fa fa-trash'></i></button>
                                                        </td>
                                                    </tr>
                                                );
                                            })
                                            :
                                            <tr>
                                                <td colSpan={6} className='text-center'>
                                                    <div className='emptyTable'>
                                                        <img src={empty_table} />
                                                        <h5 className='mt-2-new'>{t('noData')}</h5>
                                                    </div>
                                                </td>
                                            </tr>
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div className='col-md-12'>
                        <Pagination
                            className="pagination-bar"
                            currentPage={currentPage}
                            totalCount={jobs ? jobs.total : 1}
                            pageSize={PageSize}
                            onPageChange={page => changePageSize(page)}
                        />
                    </div>
                </div>
            </section>
        </div>
    );
}
export default MyJobs;